import React, { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Api from '../utils/Api';
import Constants from '../constants';

import Background from '../components/Background';
import Process2FA from '../process/Process2FA';
import Logo from '../images/logo.svg'


const PROCESS_STATES = [
    'REGISTER',
    'VALIDATE-2FA',
    'COMPLETED'
]

const Login = (props) => {

    const [error, setError] = useState(null)
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [account, setAccount] = useState(null)
    const [processState, setProcessState] = useState(PROCESS_STATES[0])
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.keyCode === 13) {
                const button = document.getElementById("loginButton");
                if (button) {
                    button.click();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const loginOn = () => {
        setLoading(true)
        setError(null)
        Api.fetch(Constants.BACKEND_APIS.login(), 'POST', { 'username': email, 'password': password }).then(resp => {
            setAccount(resp)
            setProcessState(PROCESS_STATES[1])
        }).catch(error => {
            error.json().then(e => {
                setError(e[0])
            })
        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <>
            <Background />
            <Process2FA
                account={account}
                processState={processState}
                setProcessState={setProcessState}
                redirectURL={'/'}
                noReturn={true}
                dispatch
            />

            {processState === PROCESS_STATES[0] && (
                <div className='flex items-center justify-center w-full min-h-screen px-4'>
                    <div className='w-full max-w-sm'>
                        {/* Card */}
                        <div className='rounded-2xl border p-8' style={{background: 'rgba(26,26,26,0.95)', borderColor: 'rgba(255,255,255,0.08)', boxShadow: '0 24px 64px rgba(0,0,0,0.6)'}}>
                            {/* Logo */}
                            <div className='flex flex-col items-center mb-8'>
                                <a href="/">
                                    <img src={Logo} className="h-10 mb-3" alt="Digipayments Logo" />
                                </a>
                                <h1 className='text-white text-xl font-semibold tracking-tight'>Bienvenido de vuelta</h1>
                                <p className='text-gray-500 text-sm mt-1'>Ingresá a tu cuenta</p>
                            </div>

                            {/* Error */}
                            {error && (
                                <div className='flex items-center gap-2 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2.5 mb-5'>
                                    <i className='bx bx-error-circle text-red-400 text-sm flex-shrink-0'></i>
                                    <span className='text-red-400 text-sm'>{error}</span>
                                </div>
                            )}

                            {/* Email */}
                            <div className='mb-4'>
                                <label className='block text-xs font-medium text-gray-400 mb-1.5'>Correo electrónico</label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    id="email"
                                    className="w-full px-3 py-2.5 text-sm text-white rounded-lg border focus:outline-none focus:ring-2 modal-input"
                                    style={{background: '#252525', borderColor: 'rgba(255,255,255,0.1)'}}
                                    placeholder="correo@ejemplo.com"
                                    required
                                />
                            </div>

                            {/* Password */}
                            <div className='mb-6'>
                                <label className='block text-xs font-medium text-gray-400 mb-1.5'>Contraseña</label>
                                <div className='relative'>
                                    <input
                                        onChange={(e) => setPassword(e.target.value)}
                                        value={password}
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        className="w-full px-3 py-2.5 pr-10 text-sm text-white rounded-lg border focus:outline-none modal-input"
                                        style={{background: '#252525', borderColor: 'rgba(255,255,255,0.1)'}}
                                        placeholder="••••••••"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 transition-colors duration-200'
                                    >
                                        <i className={`bx ${showPassword ? 'bx-hide' : 'bx-show'} text-lg`}></i>
                                    </button>
                                </div>
                            </div>

                            {/* Submit */}
                            <button
                                id='loginButton'
                                className="w-full py-2.5 px-4 text-sm font-semibold rounded-full button-action"
                                onClick={loginOn}
                                disabled={loading}
                            >
                                {loading ? (
                                    <span className='flex items-center justify-center gap-2'>
                                        <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                        </svg>
                                        Ingresando...
                                    </span>
                                ) : 'Ingresar'}
                            </button>

                            {/* Register link */}
                            <p className='text-center text-sm text-gray-500 mt-5'>
                                ¿No tenés cuenta?{' '}
                                <Link to="/register" className='text-blue-400 hover:text-blue-300 transition-colors duration-200'>Crear cuenta</Link>
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Login;
